var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7403_58526",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7403_58526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.0001 14.4001C7.12232 14.4001 6.29454 14.2334 5.51676 13.9001C4.73899 13.5668 4.05843 13.1084 3.4751 12.5251C2.89176 11.9418 2.43343 11.2612 2.1001 10.4834C1.76676 9.70565 1.6001 8.87788 1.6001 8.0001C1.6001 7.11121 1.76676 6.28065 2.1001 5.50843C2.43343 4.73621 2.89176 4.05843 3.4751 3.4751C4.05843 2.89176 4.73899 2.43343 5.51676 2.1001C6.29454 1.76676 7.12232 1.6001 8.0001 1.6001C8.88899 1.6001 9.71954 1.76676 10.4918 2.1001C11.264 2.43343 11.9418 2.89176 12.5251 3.4751C13.1084 4.05843 13.5668 4.73621 13.9001 5.50843C14.2334 6.28065 14.4001 7.11121 14.4001 8.0001C14.4001 8.87788 14.2334 9.70565 13.9001 10.4834C13.5668 11.2612 13.1084 11.9418 12.5251 12.5251C11.9418 13.1084 11.264 13.5668 10.4918 13.9001C9.71954 14.2334 8.88899 14.4001 8.0001 14.4001ZM8.0001 13.2001C8.61121 13.2001 9.18899 13.1001 9.73343 12.9001C10.2779 12.7001 10.7723 12.4223 11.2168 12.0668L3.93343 4.78343C3.57788 5.22788 3.3001 5.72232 3.1001 6.26676C2.9001 6.81121 2.8001 7.38899 2.8001 8.0001C2.8001 9.44454 3.30565 10.6723 4.31676 11.6834C5.32788 12.6945 6.55565 13.2001 8.0001 13.2001ZM12.0668 11.2168C12.4223 10.7723 12.7001 10.2779 12.9001 9.73343C13.1001 9.18899 13.2001 8.61121 13.2001 8.0001C13.2001 6.55565 12.6945 5.32788 11.6834 4.31676C10.6723 3.30565 9.44454 2.8001 8.0001 2.8001C7.38899 2.8001 6.81121 2.9001 6.26676 3.1001C5.72232 3.3001 5.22788 3.57788 4.78343 3.93343L12.0668 11.2168Z",
    fill: "#445386"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.e425fe21c35212637b785dd69d6a757b.svg";
export { ForwardRef as ReactComponent };